import * as React from "react";
import { Card, CardContent, CardHeader } from '@mui/material';

export default () => (
    <Card>
        <CardHeader title="Gestión de la administración" />
        <CardContent></CardContent>
    </Card>
);